import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { Container, Box, Button, TextField, Select, MenuItem, } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { userLogin } from '../../actions/userActions';
import FullscreenLoading from '../../components/Common/FullscreenLoading';
import { showAlertSnackbar } from '../../reducers/uiSlice';
import { Language } from '@material-ui/icons';
import { changeLanguagePref, getLanguagesByCountry, getLanguagePref } from '../../utilities/language';

import { useAlert } from '../../utilities/hooks';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100vh',
  },
  loginForm: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginButton: {
    marginTop: '40px',
  },
  video: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: -1,
  },
  textField: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  optionsBar: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    right: 0,
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
    },
  }
}));


export default function Login() {
  const classes = useStyles();
  const { t, i18n } = useTranslation('common');
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  const alertDialog = useAlert();

  const serverUS = process.env.REACT_APP_SERVER_COUNTRY === 'US';
  const languages = getLanguagesByCountry(serverUS ? 'us' : '');
  const languagePref = getLanguagePref()

  const user = useSelector(state => state.user);
  const common = useSelector(state => state.common);

  const [selectedLanguage, setSelectedLanguage] = useState(languagePref || 'en');

  const handleLogin = async (event) => {
    event.preventDefault();

    if (username.length === 0 || password.length === 0) {
      dispatch(showAlertSnackbar({ title: "Username or password cannot be empty!" }));
      return;
    }

    try {
      await dispatch(userLogin(username, password));
      history.push('/');
    } catch (e) {
      alertDialog.addAlertDialog("LOGIN", e.message);
      alertDialog.showAlert();
    }

  }

  const handleLanguageChange = (event) => {
    changeLanguagePref(i18n, event.target.value);
    setSelectedLanguage(event.target.value);
  }

  return (
    <div className={classes.root}>

      <video playsInline autoPlay muted loop className={classes.video}>
        <source src="./videos/login_background.mp4" type="video/mp4" />
      </video>

      <Box className={classes.optionsBar}>
        <Select
          select
          value={selectedLanguage}
          onClick={handleLanguageChange}
          startIcon={<Language />}
        >
          {
            _.map(languages, (language, index) => (
              <MenuItem
                key={`language-menu-${index}`}
                value={language.value}
              >
                {language.display_name}
              </MenuItem>
            ))
          }
        </Select>
      </Box>

      <Container maxWidth="sm">
        <Box className={classes.loginForm}>
          <form style={{ width: "80%", margin: 'auto' }}>

            <TextField className={classes.textField}
              label={t('username')}
              fullWidth
              onChange={(e) => setUsername(e.target.value)}
            />

            <TextField className={classes.textField}
              type='password'
              label={t('password')}
              fullWidth
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button className={classes.loginButton}
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleLogin}
            >
              {t('login')}
            </Button>
          </form>
        </Box>
      </Container>

      <FullscreenLoading open={user.loading || common.loading} />

    </div>
  );

}